import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { timeAgo } from "@/lib/format";
import { Bell } from "lucide-react";

export default function Notifications() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate("/"); return; }
    api.get("/notifications").then(({ data }) => setItems(data.items || [])).catch(() => {});
    api.post("/notifications/read").catch(() => {});
  }, [user, loading, navigate]);

  return (
    <div className="max-w-xl mx-auto px-4 py-8">
      <h1 className="font-display text-3xl font-bold mb-4 flex items-center gap-2"><Bell className="w-6 h-6" /> Notifications</h1>
      <div className="space-y-2">
        {items.map((n) => (
          <div key={n.id} data-testid={`notification-${n.id}`} onClick={() => n.link && navigate(n.link)}
            className={`card-brutal p-4 bg-white cursor-pointer hover:bg-secondary ${!n.read ? "border-l-8 border-l-brand" : ""}`}>
            <p className="text-sm font-medium">{n.message}</p>
            <p className="text-xs text-muted-foreground">{timeAgo(n.created_at)}</p>
          </div>
        ))}
        {items.length === 0 && <p className="text-center text-muted-foreground py-12">No notifications yet.</p>}
      </div>
    </div>
  );
}
